import { render, staticRenderFns } from "./MenuLayoutPage.vue?vue&type=template&id=7f383866&scoped=true&"
import script from "./MenuLayoutPage.vue?vue&type=script&lang=ts&"
export * from "./MenuLayoutPage.vue?vue&type=script&lang=ts&"
import style0 from "./MenuLayoutPage.vue?vue&type=style&index=0&id=7f383866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f383866",
  null
  
)

export default component.exports